function hasWhitespace(value) {
  for (let index = 0; index < value.length; index += 1) {
    const code = value.charCodeAt(index);
    if (code === 9 || code === 10 || code === 11 || code === 12 || code === 13 || code === 32) {
      return true;
    }
  }

  return false;
}

export function isValidEmail(email) {
  if (typeof email !== "string" || email.length === 0) {
    return false;
  }

  if (hasWhitespace(email)) {
    return false;
  }

  const atIndex = email.indexOf("@");
  if (atIndex <= 0 || atIndex !== email.lastIndexOf("@")) {
    return false;
  }

  const domain = email.slice(atIndex + 1);
  const lastDotIndex = domain.lastIndexOf(".");

  return lastDotIndex > 0 && lastDotIndex < domain.length - 1;
}
